var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurveArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ff0000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "curve-arrow-left-8",
    "data-name": "Flat Line",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-line",
    stroke: "#ff0000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M3,9H8.51A13.17,13.17,0,0,1,21,18",
    style: {
      fill: "none",
      stroke: "#00AA6E",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "primary-2",
    "data-name": "primary",
    points: "6 6 3 9 6 12",
    style: {
      fill: "none",
      stroke: "#00AA6E",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurveArrow);
export default __webpack_public_path__ + "static/media/curve-arrow.28e66eac3b8bbf2bc2b1d71b744f3cb4.svg";
export { ForwardRef as ReactComponent };